import { render, staticRenderFns } from "./ReflectRecordList.vue?vue&type=template&id=cc5f67ce&scoped=true&"
import script from "./ReflectRecordList.vue?vue&type=script&lang=js&"
export * from "./ReflectRecordList.vue?vue&type=script&lang=js&"
import style0 from "./ReflectRecordList.vue?vue&type=style&index=0&id=cc5f67ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5f67ce",
  null
  
)

export default component.exports